
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gZfi6", function(module, exports) {

var $ddnoW = parcelRequire("ddnoW");


var $iQwJa = parcelRequire("iQwJa");

var $bGVJw = parcelRequire("bGVJw");

var $5h1mk = parcelRequire("5h1mk");

var $1RMKR = parcelRequire("1RMKR");


var $gOWly = parcelRequire("gOWly");


var $6StHo = parcelRequire("6StHo");


var $b7cYO = parcelRequire("b7cYO");


var $6l4K1 = parcelRequire("6l4K1");


var $d3gqW = parcelRequire("d3gqW");


var $RJe7a = parcelRequire("RJe7a");


var $6J69K = parcelRequire("6J69K");


var $cozmU = parcelRequire("cozmU");


var $8aG6j = parcelRequire("8aG6j");


var $jTNdj = parcelRequire("jTNdj");


var $k4HA2 = parcelRequire("k4HA2");


var $82Ab4 = parcelRequire("82Ab4");

//#region src/message-renderer-provider/index.tsx
const $e8db06da93032c1e$var$DEFAULT_RECOMMENDATION_SESSION = {};
const $e8db06da93032c1e$export$5fe06fe68913d493 = ({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, recommendationSession: recommendationSession, messageSuccessComponent: messageSuccessComponent, componentProps: componentProps, loadingFallback: loadingFallback, triggerId: triggerId, messageCreationType: messageCreationType, postOffice: postOffice, isUFOEnabled: isUFOEnabled, children: children, SuspenseBoundary: SuspenseBoundary = (0, $cozmU.Suspense), waitForTrigger: waitForTrigger, configSetId: configSetId, journeyId: journeyId, journeyTriggerId: journeyTriggerId })=>{
    const subscriptionEnabled = (0, $gOWly.useSubscriptionConfig)().subscription?.enabled ?? false;
    /**
	* Type guard: messageContextMemo must match MessageContextData exactly.
	* If a field is missing or wrong type, the type annotation will catch it.
	*/ const loadingComponent = (0, $cozmU.useMemo)(()=>isUFOEnabled ? /* @__PURE__ */ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOLoadHold, {
            name: (0, $jTNdj.UFOv2).HoldNames.MESSAGE,
            children: loadingFallback ?? null
        }) : /* @__PURE__ */ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: loadingFallback ?? null
        }), [
        loadingFallback,
        isUFOEnabled
    ]);
    const messageContextMemo = (0, $cozmU.useMemo)(()=>({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            transactionAccountId: componentProps.transactionAccountId,
            analyticsDetails: {
                ...postOffice?.analyticsDetails,
                subscriptionEnabled: subscriptionEnabled
            },
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId
        }), [
        messageInstanceId,
        messageTemplateId,
        triggerId,
        messageCreationType,
        componentProps.transactionAccountId,
        postOffice?.analyticsDetails,
        subscriptionEnabled,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $6l4K1.MaybeChoreographerWrapper), {
        ChoreographerWrapper: $b7cYO.ChoreographerWrapper,
        enabled: !waitForTrigger,
        messageId: messageInstanceId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        children: /* @__PURE__ */ (0, $8aG6j.jsx)((0, $d3gqW.FeatureFlaggedUfoWrapper), {
            messageTemplateId: messageTemplateId,
            isEnabled: isUFOEnabled,
            children: /* @__PURE__ */ (0, $8aG6j.jsx)((0, $k4HA2.MessageContextProvider), {
                value: messageContextMemo,
                children: /* @__PURE__ */ (0, $8aG6j.jsx)((0, $82Ab4.RecommendationProvider), {
                    value: recommendationSession ?? $e8db06da93032c1e$var$DEFAULT_RECOMMENDATION_SESSION,
                    children: /* @__PURE__ */ (0, $8aG6j.jsx)(SuspenseBoundary, {
                        fallback: loadingComponent,
                        children: /* @__PURE__ */ (0, $8aG6j.jsx)((0, $RJe7a.MaybeTriggeredMessageValidator), {
                            waitForTrigger: waitForTrigger,
                            children: /* @__PURE__ */ (0, $8aG6j.jsx)((0, $6StHo.MessageAnalyticsContextProvider), {
                                children: /* @__PURE__ */ (0, $8aG6j.jsxs)((0, $6J69K.MaybeManualMessageViewedEvent), {
                                    isManual: !!waitForTrigger,
                                    children: [
                                        !waitForTrigger && messageSuccessComponent,
                                        children
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};



var $6MYaw = parcelRequire("6MYaw");


var $2WXqg = parcelRequire("2WXqg");


var $1p8wq = parcelRequire("1p8wq");





var $i3S9F = parcelRequire("i3S9F");


var $k2UaY = parcelRequire("k2UaY");


var $40SXV = parcelRequire("40SXV");




//#region src/create-placement/create-placement-component/index.tsx
const $756d79b0481f1912$var$ERROR_BOUNDARY_LOCATION = "create-placement-component";
const $756d79b0481f1912$var$createBasePlacementComponentV2 = (placementId, Component, options)=>(0, $40SXV.withErrorBoundary)((0, $cozmU.memo)((props)=>{
        const providedContext = (0, $bGVJw.usePostOfficeContext)();
        const route = (0, $5h1mk.usePostOfficeRoute)();
        const stableContext = (0, $1RMKR.useStableObject)(props?.context ?? providedContext);
        if (options?.hideInIsolatedCloud && typeof document !== "undefined" && (0, $i3S9F.isIsolatedCloud)()) return null;
        const { onEvent: onEvent, initialData: initialData, ...componentProps } = props;
        const context = props?.context ?? providedContext;
        if ((0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(context)) return null;
        return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $k2UaY.r), {
            placementId: placementId,
            children: /* @__PURE__ */ (0, $8aG6j.jsx)((0, $k2UaY.n), {
                initialData: initialData,
                onEvent: onEvent,
                children: /* @__PURE__ */ (0, $8aG6j.jsx)((0, $k2UaY.t), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    choreographer: options?.choreographer,
                    subscription: options?.subscription,
                    subscriptionAdapter: options?.subscriptionAdapter,
                    children: /* @__PURE__ */ (0, $8aG6j.jsx)(Component, {
                        initialData: initialData,
                        ...componentProps
                    })
                })
            })
        });
    }));
const $756d79b0481f1912$var$createPlacementComponentV2 = (placementId, Component, options)=>{
    const placement = $756d79b0481f1912$var$createBasePlacementComponentV2(placementId, Component, options);
    return (0, $cozmU.memo)((props)=>{
        return placement({
            ...props,
            errorBoundaryLocation: $756d79b0481f1912$var$ERROR_BOUNDARY_LOCATION,
            placementId: placementId,
            fallbackRender: ()=>null
        });
    });
};
//#endregion
//#region src/frontend/error.ts
var $756d79b0481f1912$var$PlacementMessageError = class extends Error {
    constructor(params){
        super(params.message ?? params.error?.message ?? "unknown placement message error"), (0, $ddnoW._)(this, "placementId", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "stageName", void 0), (0, $ddnoW._)(this, "placementLevel", void 0);
        this.name = params.error?.name ?? "PlacementMessageError";
        this.messageTemplateId = params.messageTemplateId;
        this.placementId = params.placementId;
        this.placementLevel = params.placementLevel;
        this.stageName = params.stageName;
        this.cause = params.error?.cause;
        this.stack = params.error?.stack;
    }
};
const $756d79b0481f1912$var$createPlacementMessageError = (error)=>{
    if (error instanceof $756d79b0481f1912$var$PlacementMessageError) return error;
    if (error instanceof Error) return new $756d79b0481f1912$var$PlacementMessageError({
        error: error
    });
    return new $756d79b0481f1912$var$PlacementMessageError({});
};
//#endregion
//#region src/frontend/create-placement-frontend.tsx
const $756d79b0481f1912$export$7ccc53e8f1e7dfc5 = (placementConfig)=>(placementRenderer)=>({
            createFrontendStage: (stage)=>stage,
            createMessageFrontend: (stage)=>(config)=>[
                        config.messageTemplateId,
                        stage
                    ],
            createPlacementFrontendComponent: (config)=>{
                const messageTemplateRouter = $756d79b0481f1912$var$createFrontendPlacementMessageTemplateRouter({
                    ...placementConfig,
                    ...config
                });
                return $756d79b0481f1912$var$createPlacementComponentV2(placementConfig.placementId, placementRenderer(messageTemplateRouter), placementConfig.options);
            }
        });
const $756d79b0481f1912$var$createFrontendPlacementMessageRunner = ({ messageTemplates: messageTemplates, ...config })=>({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, messageCategory: messageCategory, children: children, ...props })=>{
        const renderableStage = messageTemplates?.[messageTemplateId];
        const isHeadless = config.headlessMessageTemplateIds?.includes(messageTemplateId);
        const placementLocation = {
            messageTemplateId: messageTemplateId,
            messageInstanceId: messageInstanceId,
            placementLevel: "Message",
            stageName: config?.stageName,
            placementId: config.placementId
        };
        (0, $cozmU.useEffect)(()=>{
            if (isHeadless && renderableStage) console.error(new $756d79b0481f1912$var$PlacementMessageError({
                ...placementLocation,
                ...config
            }), "Misconfiguration: message is registered as both headless and has a MessageFrontend renderer. Remove it from headlessMessageTemplateIds or remove the MessageFrontend export.");
            if (!isHeadless && !renderableStage) console.error(new $756d79b0481f1912$var$PlacementMessageError({
                ...placementLocation,
                ...config
            }), "Misconfiguration: message is not registered as headless but has no MessageFrontend renderer. Register it as a headless message by reinstalling or add a MessageFrontend export.");
        }, [
            isHeadless,
            placementLocation,
            renderableStage,
            config
        ]);
        const componentPropsStable = (0, $1RMKR.useStableObject)(props);
        const messageProps = props;
        const triggerType = messageProps.triggerType ?? messageProps.context?.triggerType;
        const hasTrigger = (0, $1p8wq.isClientTriggeredMessage)(triggerType);
        const { waitForTrigger: waitForTrigger } = (0, $2WXqg.useWaitForTrigger)({
            hasTrigger: hasTrigger,
            messageSuccessComponent: void 0,
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
        if (!renderableStage) return null;
        try {
            renderableStage.validate({
                messageTemplateId: messageTemplateId,
                children: children,
                ...props
            });
            const { Component: Component } = renderableStage;
            return /* @__PURE__ */ (0, $8aG6j.jsxs)((0, $e8db06da93032c1e$export$5fe06fe68913d493), {
                ...componentPropsStable,
                messageTemplateId: messageTemplateId,
                messageInstanceId: messageInstanceId,
                messageCategory: messageCategory,
                isUFOEnabled: false,
                componentProps: componentPropsStable,
                waitForTrigger: waitForTrigger,
                children: [
                    !waitForTrigger && /* @__PURE__ */ (0, $8aG6j.jsx)((0, $6MYaw.MessageViewed), {}),
                    /* @__PURE__ */ (0, $8aG6j.jsx)(Component, {
                        ...props,
                        waitForTrigger: waitForTrigger,
                        children: children
                    })
                ]
            });
        } catch (error) {
            console.error($756d79b0481f1912$var$createPlacementMessageError(error));
            return null;
        }
    };
const $756d79b0481f1912$var$createFrontendPlacementMessageTemplateRouter = (config)=>{
    const messageTemplateLookup = $756d79b0481f1912$var$createMessageTemplateByStageLookup(config);
    return Object.entries(messageTemplateLookup).reduce((base, [stageName, messageTemplates])=>({
            ...base,
            [stageName]: $756d79b0481f1912$var$createFrontendPlacementMessageRunner({
                messageTemplates: messageTemplates,
                stageName: stageName,
                placementId: config.placementId,
                headlessMessageTemplateIds: config.headlessMessageTemplateIds
            })
        }), {});
};
const $756d79b0481f1912$var$createMessageTemplateByStageLookup = (config)=>{
    const result = {};
    config.messageTemplates.forEach(([messageTemplateId, stage])=>{
        Object.entries(stage).forEach(([stageName, stageExecutable])=>{
            if (!result[stageName]) result[stageName] = {};
            result[stageName][messageTemplateId] = stageExecutable;
        });
    });
    return result;
};
//#endregion
//#region src/frontend/create-headless-message-frontend.ts
/**
* Creates a placeholder frontend entry for a headless message installed in a backend+frontend placement.
*
* A headless message provides only a MessageBackend — its rendering is handled in-product by the
* consuming team (e.g. via usePlacementData). This factory creates a no-op FrontendPlacementMessage
* so the message template ID is still registered in messageFrontends and the placement can track it
* via headlessMessageTemplateIds.
*
* Usage in a generated placement file:
*   import { createHeadlessMessageFrontend } from '@post-office/placement-common-v2/frontend';
*   const messageFrontends = [
*     createMessageFrontendMyMessage({ messageTemplateId: 'my-message' }),
*     createHeadlessMessageFrontend({ messageTemplateId: 'headless-msg' }),
*   ];
*/ const $756d79b0481f1912$export$625550452a3fa3ec = ({ messageTemplateId: messageTemplateId })=>[
        messageTemplateId,
        {}
    ];



var $B9QgK = parcelRequire("B9QgK");



//#region src/create-placement/index.tsx
/**
* @deprecated Import environment-specific APIs from /frontend or /backend instead.
*/ const $c5de345048f9b341$export$a2cfeb566a0f6574 = (placementConfig)=>{
    return {
        createFrontend: (0, $756d79b0481f1912$export$7ccc53e8f1e7dfc5)(placementConfig),
        createBackend: (0, $B9QgK.i)(placementConfig)
    };
};
module.exports["createPlacement"] = $c5de345048f9b341$export$a2cfeb566a0f6574;

});

parcelRegister("B9QgK", function(module, exports) {
//#region src/stages/placement/backend/index.ts
const $4d2220aefc63aef8$var$maybe = (stage)=>async (params)=>{
        return stage?.(params) ?? params.data;
    };
const $4d2220aefc63aef8$var$mergeMetadata = (fn)=>{
    const applyMerge = (target, source)=>{
        {
            const sourceMap = Object.fromEntries(source.messages.map((message)=>[
                    message.messageInstanceId,
                    message
                ]));
            return {
                messages: target.data.messages.map((message)=>fn(message, sourceMap?.[message.messageInstanceId]?.context))
            };
        }
    };
    return applyMerge;
};
const $4d2220aefc63aef8$export$43caf9889c228507 = {
    maybe: /**
	* The `maybe` function creates a passthrough stage,
	* which applies no changes, for cases where a stage might be undefined.
	*/ $4d2220aefc63aef8$var$maybe,
    mergeMetadata: /**
	* the `mergeMetadata` function is used when the result of a stage is
	* used to modify the message payload outside the message context
	*/ $4d2220aefc63aef8$var$mergeMetadata
};
//#endregion
//#region src/stages/placement/backend/hydrate/index.ts
const $4d2220aefc63aef8$var$applyHydrate = (hydrate)=>$4d2220aefc63aef8$export$43caf9889c228507.maybe(hydrate);
//#endregion
//#region src/stages/placement/backend/transform-metadata/index.ts
const $4d2220aefc63aef8$var$applyTransformMetadata = (transformMetadata)=>async (params)=>{
        const transformedMetadata = await $4d2220aefc63aef8$export$43caf9889c228507.maybe(transformMetadata)(params);
        const placementId = params?.request?.orchestrationContext?.placementId ?? "no-placement-found";
        return $4d2220aefc63aef8$export$43caf9889c228507.mergeMetadata((original, metadata)=>({
                ...original,
                enrichedAttributes: {
                    "in-app": {
                        [placementId]: metadata
                    }
                }
            }))(params, transformedMetadata);
    };
//#endregion
//#region src/stages/placement/backend/default/index.ts
const $4d2220aefc63aef8$export$7ccc53e8f1e7dfc5 = ({ transformMetadata: transformMetadata, hydrate: hydrate })=>({
        init: $4d2220aefc63aef8$var$applyTransformMetadata(transformMetadata),
        postInit: $4d2220aefc63aef8$var$applyHydrate(hydrate)
    });
//#endregion
//#region src/stages/placement-message/backend/transform-metadata/default/index.ts
const $4d2220aefc63aef8$export$625550452a3fa3ec = ()=>({
        goalMetadata: {
            primaryGoal: {
                goalId: "clickthrough"
            }
        }
    });



var $fs98n = parcelRequire("fs98n");


var $ddnoW = parcelRequire("ddnoW");


var $o0RSX = parcelRequire("o0RSX");

var $eb8eb3b792f36778$var$_MissingPlacementIdError;
//#region src/create-placement/error/index.ts
/**
* Thrown when createPlacementBackend is called with an empty placementId.
* This prevents DefaultHeadlessPlacementBackend's internal factory from
* accidentally reaching production — it only exposes createMessageBackend
* and useDefaultMessageBackend. The production placement backend with the
* correct placementId is created at install time by the CLI.
*/ var $eb8eb3b792f36778$export$625550452a3fa3ec = ($eb8eb3b792f36778$var$_MissingPlacementIdError = class MissingPlacementIdError extends Error {
    constructor(){
        super(MissingPlacementIdError.message);
        this.name = "MissingPlacementIdError";
    }
}, (0, $ddnoW._)($eb8eb3b792f36778$var$_MissingPlacementIdError, "message", "createPlacementBackend requires a non-empty placementId. DefaultHeadlessPlacementBackend only provides createMessageBackend and useDefaultMessageBackend. The production placement (with the correct placementId) is created at install time by the CLI."), $eb8eb3b792f36778$var$_MissingPlacementIdError);
var $eb8eb3b792f36778$export$43caf9889c228507 = class extends (0, $o0RSX.PostOfficeError) {
    constructor(params){
        const message = params.message ?? params.error?.message ?? "unknown placement system error";
        const code = params.code ?? (0, $o0RSX.PostOfficeErrorCodes).PlacementSystemError;
        super(message, code), (0, $ddnoW._)(this, "placementId", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "stageName", void 0), (0, $ddnoW._)(this, "placementLevel", void 0);
        this.name = params.error?.name ?? this.constructor.name;
        this.messageTemplateId = params.messageTemplateId;
        this.placementId = params.placementId;
        this.placementLevel = params.placementLevel;
        this.stageName = params.stageName;
        this.cause = params.error?.cause;
        this.stack = params.error?.stack;
    }
};
var $eb8eb3b792f36778$export$7ccc53e8f1e7dfc5 = class extends $eb8eb3b792f36778$export$43caf9889c228507 {
    constructor(params){
        super({
            ...params,
            message: "unknown placement message error",
            code: (0, $o0RSX.PostOfficeErrorCodes).PlacementMessageError
        });
    }
};
var $eb8eb3b792f36778$var$PlacementRuntimeError = class extends $eb8eb3b792f36778$export$43caf9889c228507 {
    constructor(params){
        super({
            ...params,
            message: "unknown placement runtime error",
            code: (0, $o0RSX.PostOfficeErrorCodes).PlacementRuntimeError
        });
    }
};
var $eb8eb3b792f36778$var$PlacementMiddlewareError = class extends $eb8eb3b792f36778$export$43caf9889c228507 {
    constructor(params){
        super({
            ...params,
            message: "unknown placement middleware error",
            code: (0, $o0RSX.PostOfficeErrorCodes).PlacementRuntimeError
        });
    }
};
const $eb8eb3b792f36778$var$createPlacementErrorFactory = (errorType)=>(error)=>{
        if (error instanceof errorType) return new errorType({
            ...error,
            error: error
        });
        if (error instanceof Error) return new errorType({
            error: error
        });
        return new errorType({});
    };
const $eb8eb3b792f36778$var$createPlacementMessageError = $eb8eb3b792f36778$var$createPlacementErrorFactory($eb8eb3b792f36778$export$43caf9889c228507);
const $eb8eb3b792f36778$export$407448d2b89b1813 = (request)=>(error)=>$eb8eb3b792f36778$var$logPlacementError(request)($eb8eb3b792f36778$var$createPlacementMessageError(error));
const $eb8eb3b792f36778$var$createPlacementError = $eb8eb3b792f36778$var$createPlacementErrorFactory($eb8eb3b792f36778$export$43caf9889c228507);
const $eb8eb3b792f36778$export$23f2a1d2818174ef = (request)=>(error)=>$eb8eb3b792f36778$var$logPlacementError(request)($eb8eb3b792f36778$var$createPlacementError(error));
const $eb8eb3b792f36778$var$createPlacementSystemError = $eb8eb3b792f36778$var$createPlacementErrorFactory($eb8eb3b792f36778$export$43caf9889c228507);
const $eb8eb3b792f36778$export$db3b6bfb95261072 = (request)=>(error)=>$eb8eb3b792f36778$var$logPlacementError(request)($eb8eb3b792f36778$var$createPlacementSystemError(error));
const $eb8eb3b792f36778$var$createPlacementRuntimeError = $eb8eb3b792f36778$var$createPlacementErrorFactory($eb8eb3b792f36778$var$PlacementRuntimeError);
const $eb8eb3b792f36778$export$2408f22a0fab9ae5 = (request)=>(error)=>$eb8eb3b792f36778$var$logPlacementError(request)($eb8eb3b792f36778$var$createPlacementRuntimeError(error));
const $eb8eb3b792f36778$var$createPlacementMiddlewareError = $eb8eb3b792f36778$var$createPlacementErrorFactory($eb8eb3b792f36778$var$PlacementMiddlewareError);
const $eb8eb3b792f36778$export$ae1af26003f05816 = (request)=>(error)=>$eb8eb3b792f36778$var$logPlacementError(request)($eb8eb3b792f36778$var$createPlacementMiddlewareError(error));
const $eb8eb3b792f36778$var$logPlacementError = (request)=>(error)=>{
        request.logger.error({
            message: error.message,
            cause: error.cause,
            name: error.name,
            stack: error.stack,
            placementLevel: error.placementLevel
        });
        return error;
    };



var $cXtTj = parcelRequire("cXtTj");




//#region src/index.ts
const $27a4e02d03060067$export$6d7470db509fd15d = [
    "admin",
    "aha",
    "analytics",
    "atlas",
    "atlassianStudio",
    "billingConsole",
    "bitbucket",
    "cmdb",
    "confluence-highlight-issue-create",
    "confluence-highlight-issue-create-ai",
    "confluence-whiteboards",
    "confluence",
    "confluence.ondemand",
    "cssXp",
    "databricks",
    "drive",
    "github",
    "identity",
    "jira",
    "jira-product-discovery",
    "jira-servicedesk",
    "jira-servicedesk.ondemand",
    "loom",
    "marketing",
    "mercury",
    "miro",
    "onedrive",
    "opsgenie",
    "outlook-calendar",
    "partner-unified-xp",
    "pop3",
    "rovo",
    "rovo-extension",
    "rovoChat",
    "salesforce",
    "sharepoint",
    "slack",
    "statuspage",
    "townsquare",
    "trello",
    "universalCreate",
    "zendesk"
];
const $27a4e02d03060067$var$IN_APP_ALLOWED_PRODUCT_SET = new Set($27a4e02d03060067$export$6d7470db509fd15d);
const $27a4e02d03060067$export$8278f7055159c0ba = (product)=>$27a4e02d03060067$var$IN_APP_ALLOWED_PRODUCT_SET.has(product);


//#region src/metrics-with-contextual-tags/index.ts
/**
* Creates a Metrics middleware compatible object {@see @atlassian/metrics-interface}
* that enriches every method with contextual tags without modifying metrics name as opposed to
* using metrics.child(name, tags) method which prepends its name to every metric.
*
* @param metrics
* @param contextualTags
*/ function $d2295b448b0f646b$export$e455422cde52a061(metrics, contextualTags) {
    return {
        child (name, tags) {
            return metrics.child(name, {
                ...contextualTags,
                ...tags
            });
        },
        counter (name, tags) {
            return metrics.counter(name, {
                ...contextualTags,
                ...tags
            });
        },
        event (title, description) {
            return metrics.event(title, description);
        },
        gauge (name, tags) {
            return metrics.gauge(name, {
                ...contextualTags,
                ...tags
            });
        },
        histogram (name, buckets, tags) {
            return metrics.histogram(name, buckets, {
                ...contextualTags,
                ...tags
            });
        },
        set (name, tags) {
            return metrics.set(name, {
                ...contextualTags,
                ...tags
            });
        },
        timing (name, tags) {
            return metrics.timing(name, {
                ...contextualTags,
                ...tags
            });
        }
    };
}
//#endregion
//#region src/trace-id.ts
/**
* B3 trace IDs must be 16 or 32 hex characters; randomUUID() includes hyphens,
* so remove them to produce a valid 32-character trace ID.
*/ function $d2295b448b0f646b$export$eb139a1a52c68fda() {
    return globalThis.crypto.randomUUID().replace(/-/g, "");
}
//#endregion
//#region src/metrics-product-normalizer/index.ts
const $d2295b448b0f646b$export$4b878dfc38059779 = [
    ...(0, $27a4e02d03060067$export$6d7470db509fd15d),
    "unknown"
];
const $d2295b448b0f646b$var$maxProductValueLength = $d2295b448b0f646b$export$4b878dfc38059779.reduce((max, value)=>Math.max(max, value.length), 0);
const $d2295b448b0f646b$var$sanitizedProductValuesSet = new Set($d2295b448b0f646b$export$4b878dfc38059779);
function $d2295b448b0f646b$export$ab03f5860d96b3e3(input, logger) {
    if (input.length > $d2295b448b0f646b$var$maxProductValueLength) {
        logger.warn({
            input: input
        }, "Product value is too long to be valid, returning unknown");
        return "unknown";
    }
    if ($d2295b448b0f646b$var$sanitizedProductValuesSet.has(input)) return input;
    const lowerCasedInput = input.toLowerCase();
    if ($d2295b448b0f646b$var$sanitizedProductValuesSet.has(lowerCasedInput)) return lowerCasedInput;
    logger.warn({
        input: input
    }, "Product value is not recognized, returning unknown");
    return "unknown";
}
//#endregion
//#region src/high-cardinality-metric-tag-overrides/index.ts
const $d2295b448b0f646b$var$DISABLED_METRIC_TAG_VALUE = "disabled";
const $d2295b448b0f646b$export$e924d1234600a844 = Object.freeze(Object.fromEntries([
    "deployment_id",
    "micros_service_version",
    "region",
    "micros_zone",
    "obs_sfx_enable",
    "container_name"
].map((tagName)=>[
        tagName,
        $d2295b448b0f646b$var$DISABLED_METRIC_TAG_VALUE
    ])));


//#region src/message-performance.ts
const $eeedeb00cf693440$var$PULL_MESSAGE_PERFORMANCE_PER_PLACEMENT = "message-performance.pull.per-placement";
const $eeedeb00cf693440$var$PUSH_MESSAGE_PERFORMANCE_PER_RECIPIENT_TYPE = "message-performance.push.per-recipient-type";
const $eeedeb00cf693440$var$HISTOGRAM_BUCKETS = {
    pull: {
        perStage: [
            10,
            25,
            50,
            100,
            150,
            200,
            250,
            300,
            400,
            500
        ],
        endToEnd: [
            25,
            100,
            200,
            300,
            400,
            500
        ]
    },
    push: {
        perStage: [
            100,
            500,
            1e3
        ],
        endToEnd: [
            100,
            500,
            1e3,
            5e3
        ]
    }
};
const $eeedeb00cf693440$var$defaultOptions = {
    logThreshold: 500,
    trackEndToEnd: false
};
/**
* Tracks performance for message processing.
*
* Responsibilities:
* 1) Measure each operation and emit timer + histogram metrics.
* 2) Keep a per message template id per layer cumulative timer -
* 	how much time was spend running all stages of message maker's code for a given message VS how much time was spend running Post Office orchestration code.
* 3) Optionally track end-to-end timing and emit logs if the total execution time exceeds a specified threshold.
*
* Public API is intentionally small:
* - `measureOperation`: wraps one async operation.
* - `stop`: flushes cumulative layer timings and final logging/metrics.
*/ var $eeedeb00cf693440$export$f5bd5a7a850da66e = class {
    /**
	* Wraps one async operation with timing instrumentation.
	*
	* Flow:
	* 1) Start stage metrics (timer + histogram).
	* 2) Execute callback.
	* 3) Record layer + longest-stage bookkeeping.
	* 4) Stop stage metrics with success/failure status.
	*/ async measureOperation(callback, tags, context) {
        const operationStart = performance.now();
        const stageMetricName = this.getMetricName(tags.stage);
        const histogramBuckets = $eeedeb00cf693440$var$HISTOGRAM_BUCKETS[this.options.metricNameSegments.flow].perStage;
        const histogram = this.observability.metrics.histogram(stageMetricName, histogramBuckets).measure();
        const timer = this.observability.metrics.timing(stageMetricName).measure();
        let status = "success";
        try {
            return await callback();
        } catch (error) {
            status = "failure";
            throw error;
        } finally{
            const operationEndTime = performance.now();
            const operationLatency = operationEndTime - operationStart;
            this.recordOperationIntervalPerLayerPerMessage(tags.messageTemplateId, context.layer, operationStart, operationEndTime);
            this.updateSlowestOperationPerStagePerMessage(tags, context.layer, operationLatency);
            const operationMetricTags = this.applyTagOverrides({
                ...tags,
                status: status
            });
            histogram.stop(operationMetricTags);
            timer.stop(operationMetricTags);
        }
    }
    /**
	* Finalizes recording for this instance.
	*
	* Always publishes per-layer cumulative timings.
	* If end-to-end is enabled, also stops e2e metrics and logs slow executions.
	*/ stop() {
        this.publishTotalLayerLatencyPerMessage();
        if (!this.options.trackEndToEnd) return;
        const totalTime = performance.now() - this.startTime;
        this.publishEndToEndFlowLatency(totalTime);
        this.logThresholdExceeded(totalTime);
    }
    logThresholdExceeded(totalTime) {
        const logThreshold = this.options.logThreshold ?? $eeedeb00cf693440$var$defaultOptions.logThreshold;
        if (totalTime > logThreshold && this.slowestOperationPerStagePerMessage.size > 0) {
            const operationSequence = Array.from(this.slowestOperationPerStagePerMessage.values());
            this.observability.logger.info({
                totalTime: totalTime,
                logThreshold: logThreshold,
                operationSequence: operationSequence
            }, "Message performance threshold exceeded");
        }
    }
    getMetricName(suffix) {
        return this.options.metricNameSegments.flow === "pull" ? `${$eeedeb00cf693440$var$PULL_MESSAGE_PERFORMANCE_PER_PLACEMENT}.${this.options.metricNameSegments.placementId}.${suffix}` : `${$eeedeb00cf693440$var$PUSH_MESSAGE_PERFORMANCE_PER_RECIPIENT_TYPE}.${this.options.metricNameSegments.recipientType}.${suffix}`;
    }
    applyTagOverrides(tags) {
        return {
            ...tags,
            ...(0, $d2295b448b0f646b$export$e924d1234600a844)
        };
    }
    recordOperationIntervalPerLayerPerMessage(messageTemplateId, layer, operationStartTimeMs, operationEndTimeMs) {
        const key = `${layer}:${messageTemplateId}`;
        const existingIntervals = this.operationIntervalsPerLayerPerMessage.get(key) ?? [];
        existingIntervals.push({
            startTimeMs: operationStartTimeMs,
            endTimeMs: operationEndTimeMs
        });
        this.operationIntervalsPerLayerPerMessage.set(key, existingIntervals);
    }
    calculateTotalDurationForLayers(intervals) {
        if (intervals.length === 0) return 0;
        const sortedIntervals = intervals.toSorted((firstInterval, secondInterval)=>{
            return firstInterval.startTimeMs - secondInterval.startTimeMs;
        });
        const mergedIntervals = [];
        for (const currentInterval of sortedIntervals){
            const lastMergedInterval = mergedIntervals[mergedIntervals.length - 1];
            if (!lastMergedInterval || currentInterval.startTimeMs > lastMergedInterval.endTimeMs) {
                mergedIntervals.push({
                    ...currentInterval
                });
                continue;
            }
            lastMergedInterval.endTimeMs = Math.max(lastMergedInterval.endTimeMs, currentInterval.endTimeMs);
        }
        return mergedIntervals.reduce((totalDuration, interval)=>totalDuration + (interval.endTimeMs - interval.startTimeMs), 0);
    }
    updateSlowestOperationPerStagePerMessage(tags, layer, durationMs) {
        const key = `${tags.stage}:${tags.messageTemplateId}`;
        const existing = this.slowestOperationPerStagePerMessage.get(key);
        if (!existing || durationMs > existing.timeMs) this.slowestOperationPerStagePerMessage.set(key, {
            messageTemplateId: tags.messageTemplateId,
            stage: tags.stage,
            timeMs: durationMs,
            layer: layer
        });
    }
    publishTotalLayerLatencyPerMessage() {
        for (const [layer, operationIntervals] of this.operationIntervalsPerLayerPerMessage){
            const [layerName, messageTemplateId] = layer.split(":");
            const metricName = this.getMetricName(layerName);
            const totalLayerDuration = this.calculateTotalDurationForLayers(operationIntervals);
            const buckets = $eeedeb00cf693440$var$HISTOGRAM_BUCKETS[this.options.metricNameSegments.flow].endToEnd;
            const tags = this.applyTagOverrides({
                messageTemplateId: messageTemplateId
            });
            this.observability.metrics.timing(metricName, tags).set(totalLayerDuration);
            this.observability.metrics.histogram(metricName, buckets, tags).set(totalLayerDuration);
        }
    }
    publishEndToEndFlowLatency(totalTime) {
        const metricName = this.getMetricName("e2e");
        const buckets = $eeedeb00cf693440$var$HISTOGRAM_BUCKETS[this.options.metricNameSegments.flow].endToEnd;
        const tags = this.applyTagOverrides({});
        this.observability.metrics.timing(metricName, tags).set(totalTime);
        this.observability.metrics.histogram(metricName, buckets, tags).set(totalTime);
    }
    constructor(observability, options){
        (0, $ddnoW._)(this, "observability", void 0);
        (0, $ddnoW._)(this, "options", void 0);
        (0, $ddnoW._)(this, "startTime", performance.now());
        (0, $ddnoW._)(this, "slowestOperationPerStagePerMessage", /* @__PURE__ */ new Map());
        (0, $ddnoW._)(this, "operationIntervalsPerLayerPerMessage", /* @__PURE__ */ new Map());
        this.observability = observability;
        this.options = options;
    }
};



//#region src/stages/placement-message/backend/default/index.ts
const $06fb173e15603c4d$var$defaultBackendPlacementMessageStages = {};
//#endregion
//#region src/create-placement/util/message-helpers/index.ts
const $06fb173e15603c4d$export$ae1af26003f05816 = ()=>({
        transformMetadata: {
            validate: $06fb173e15603c4d$export$2408f22a0fab9ae5(),
            stage: (0, $4d2220aefc63aef8$export$625550452a3fa3ec)
        }
    });
const $06fb173e15603c4d$export$2408f22a0fab9ae5 = (_valueWithType)=>(input)=>input;
//#endregion
//#region src/create-placement/util/observability/index.ts
const $06fb173e15603c4d$var$HISTOGRAM_LATENCY_INTERVAL_BUCKETS = [
    25,
    50,
    100,
    150,
    200,
    250,
    500,
    1e3
];
const $06fb173e15603c4d$var$timerName = "post-office.placement-v2.stage.execute";
const $06fb173e15603c4d$var$counterName = "post-office.placement-v2.stage.result";
const $06fb173e15603c4d$var$hasDelta = (tags)=>{
    if (!tags || typeof tags.delta !== "object" || tags.delta === null) return false;
    const delta = tags.delta;
    return typeof delta.number === "number" && delta.number !== 0;
};
const $06fb173e15603c4d$var$createTimedStage = ({ tag: tag } = {})=>(stage)=>async (params)=>{
            const startTime = performance.now();
            const { stop: stop } = params.request.metrics.histogram($06fb173e15603c4d$var$timerName, $06fb173e15603c4d$var$HISTOGRAM_LATENCY_INTERVAL_BUCKETS, (0, $d2295b448b0f646b$export$e924d1234600a844)).measure();
            const result = stage(params);
            let tags;
            try {
                const unwrappedResult = result instanceof Promise ? await result : result;
                try {
                    tags = tag?.({
                        input: params,
                        output: unwrappedResult
                    });
                } catch  {
                    params.request.logger.warn("Unable to apply tags to stage logs");
                }
                params.request.metrics.counter($06fb173e15603c4d$var$counterName, {
                    status: "success"
                }).incr();
                return unwrappedResult;
            } catch (error) {
                params.request.metrics.counter($06fb173e15603c4d$var$counterName, {
                    status: "error"
                }).incr();
                throw error;
            } finally{
                stop();
                const latencyInMs = performance.now() - startTime;
                if (params.request.statsig.checkGate({
                    identifiers: {
                        tenantId: params.request.orchestrationContext.tenantId ?? ""
                    }
                }, "post-office_enable-unified-finish-logs") ? (tag !== void 0 ? $06fb173e15603c4d$var$hasDelta : ()=>false)(tags) : true) params.request.logger.info({
                    latencyInMs: latencyInMs,
                    ...tags
                }, "Finished stage");
            }
        };
const $06fb173e15603c4d$var$createTimedSystemStage = (fn)=>(contexts)=>{
        return async (params)=>{
            const startTime = performance.now();
            const { stop: stop } = contexts.request.metrics.histogram($06fb173e15603c4d$var$timerName, $06fb173e15603c4d$var$HISTOGRAM_LATENCY_INTERVAL_BUCKETS, (0, $d2295b448b0f646b$export$e924d1234600a844)).measure();
            const result = fn(contexts)(params);
            try {
                const unwrappedResult = await result;
                contexts.request.metrics.counter($06fb173e15603c4d$var$counterName, {
                    status: "success"
                }).incr();
                return unwrappedResult;
            } catch (error) {
                contexts.request.metrics.counter($06fb173e15603c4d$var$counterName, {
                    status: "error"
                }).incr();
                throw error;
            } finally{
                stop();
                const latencyInMs = performance.now() - startTime;
                contexts.request.logger.info({
                    latencyInMs: latencyInMs
                }, "Finished stage");
            }
        };
    };
const $06fb173e15603c4d$var$messageTimedStage = $06fb173e15603c4d$var$createTimedStage({});
const $06fb173e15603c4d$var$placementTimedStage = $06fb173e15603c4d$var$createTimedStage({
    tag: ({ input: input, output: output })=>{
        if (!output) return {};
        const inputMessageTemplateIdsSet = new Set(input.data.messages.map((message)=>message.messageTemplateId));
        const inputMessageTemplateIds = Array.from(inputMessageTemplateIdsSet.values());
        const outputMessageTemplateIdsSet = new Set(output.messages.map((message)=>message.messageTemplateId));
        const outputMessageTemplateIds = Array.from(outputMessageTemplateIdsSet.values());
        const deltaMessageTemplateIds = inputMessageTemplateIds.filter((id)=>!outputMessageTemplateIdsSet.has(id));
        const inputMessageInstanceIds = input.data.messages.map(({ messageInstanceId: messageInstanceId })=>messageInstanceId);
        const outputMessageInstanceIdsSet = new Set(output.messages.map(({ messageInstanceId: messageInstanceId })=>messageInstanceId));
        const outputMessageInstanceIds = Array.from(outputMessageInstanceIdsSet.values());
        const deltaMessageInstanceIds = inputMessageInstanceIds.filter((id)=>!outputMessageInstanceIdsSet.has(id));
        return {
            input: {
                number: input.data.messages.length,
                messageTemplateIds: inputMessageTemplateIds,
                messageInstanceIds: inputMessageInstanceIds
            },
            output: {
                number: output.messages.length,
                messageTemplateIds: outputMessageTemplateIds,
                messageInstanceIds: outputMessageInstanceIds
            },
            delta: {
                number: output.messages.length - input.data.messages.length,
                messageTemplateIds: deltaMessageTemplateIds,
                messageInstanceIds: deltaMessageInstanceIds
            }
        };
    }
});
const $06fb173e15603c4d$var$placementRuntimeTimedStage = $06fb173e15603c4d$var$createTimedSystemStage;
const $06fb173e15603c4d$var$logRuntimeResult = ({ request: request })=>({ result: result, latencyInMs: latencyInMs })=>{
        const errorMessageTemplateIds = Array.from(new Set(result.errors.map((e)=>e.messageTemplateId)).values());
        const messageTemplateIds = Array.from(new Set(result.data.messages.map((e)=>e.messageTemplateId)).values());
        const formattedMessages = result.data.messages.map(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, messageCreationType: messageCreationType, messageCategory: messageCategory, triggerId: triggerId })=>({
                messageTemplateId: messageTemplateId,
                messageInstanceId: messageInstanceId,
                messageCreationType: messageCreationType,
                messageCategory: messageCategory,
                triggerId: triggerId
            }));
        const formattedErrorDetails = result.errors.map(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, reason: reason })=>({
                messageTemplateId: messageTemplateId,
                messageInstanceId: messageInstanceId,
                reason: reason
            }));
        request.logger.info({
            latencyInMs: latencyInMs,
            errors: {
                number: result.errors.length,
                messageTemplateIds: errorMessageTemplateIds,
                messageDetails: formattedErrorDetails
            },
            messages: {
                number: result.data.messages.length,
                messageTemplateIds: messageTemplateIds,
                messageDetails: formattedMessages
            }
        }, "Runtime result");
    };
//#endregion
//#region src/create-placement/backend-factory.ts
const $06fb173e15603c4d$export$407448d2b89b1813 = (stages)=>(messageBackendConfig)=>{
        const stagesWithDefaults = $06fb173e15603c4d$var$applyDefaultMessageBackendStages(stages);
        return [
            messageBackendConfig.messageTemplateId,
            stagesWithDefaults
        ];
    };
const $06fb173e15603c4d$export$23f2a1d2818174ef = (placementConfig)=>(placementBackendParams)=>({
            createBackendStage: (stage)=>stage,
            createMessageBackend: (stages)=>$06fb173e15603c4d$export$407448d2b89b1813(stages),
            createPlacementBackend: (placementBackendConfig)=>(runtime)=>{
                    const placementId = placementConfig.placementId;
                    if (!placementId) throw new (0, $eb8eb3b792f36778$export$625550452a3fa3ec)();
                    const placementBackendStages = placementBackendParams?.stages ?? (0, $4d2220aefc63aef8$export$7ccc53e8f1e7dfc5);
                    const placementStages = $06fb173e15603c4d$export$43caf9889c228507(placementBackendStages);
                    const messagesStages = $06fb173e15603c4d$export$7ccc53e8f1e7dfc5({
                        ...placementConfig,
                        ...placementBackendConfig
                    });
                    const statelessMiddleware = (placementBackendParams?.customMiddleware ?? (0, $fs98n.n))({
                        ...placementConfig,
                        ...placementBackendParams?.params
                    });
                    const statelessMessagesRuntime = runtime({
                        messagesStages: messagesStages,
                        placementStages: placementStages,
                        placementId: placementId
                    });
                    const withRequestMetadata = (ctx)=>{
                        if (ctx.header?.["x-include-request-metadata"] === "true") {
                            const state = ctx.state;
                            ctx.body.requestMetadata = {
                                ...describe(),
                                graph: (0, $cXtTj.default).checkGate("post_office_enable-visualization") ? state.requestContext.location.getGraph() : void 0
                            };
                        }
                    };
                    const buildPlacementContext = (ctx, next)=>{
                        const koa = {
                            ctx: ctx,
                            next: next
                        };
                        const request = ctx.state.requestContext.location.tag({
                            placementId: placementConfig.placementId
                        });
                        const messagesRuntime = async (config)=>{
                            const configuredRequest = (config?.request ?? request).location.tag({
                                placementLevel: "Runtime"
                            });
                            if (!configuredRequest) throw new (0, $eb8eb3b792f36778$export$43caf9889c228507)({
                                message: "request context not available at runtime call"
                            });
                            const contexts = {
                                koa: koa,
                                request: configuredRequest
                            };
                            const combinedParams = {
                                ...placementBackendParams?.params,
                                ...config?.params
                            };
                            try {
                                const runtimeStartTime = performance.now();
                                const result = await $06fb173e15603c4d$var$placementRuntimeTimedStage(statelessMessagesRuntime)(contexts)(combinedParams);
                                const runtimeLatencyInMs = performance.now() - runtimeStartTime;
                                $06fb173e15603c4d$var$logRuntimeResult(contexts)({
                                    result: result,
                                    latencyInMs: runtimeLatencyInMs
                                });
                                return result;
                            } catch (error) {
                                throw (0, $eb8eb3b792f36778$export$2408f22a0fab9ae5)(contexts.request)(error);
                            }
                        };
                        return {
                            koa: koa,
                            request: request,
                            postOffice: {
                                messagesRuntime: messagesRuntime
                            },
                            messagesRuntime: messagesRuntime
                        };
                    };
                    const koaMiddleware = async (ctx, next)=>{
                        const { koa: koa, request: request, postOffice: postOffice } = buildPlacementContext(ctx, next);
                        const middlewareRequest = request.location.tag({
                            placementLevel: "Middleware"
                        });
                        try {
                            await statelessMiddleware({
                                koa: koa,
                                postOffice: postOffice,
                                request: middlewareRequest,
                                placement: placementConfig
                            });
                        } catch (error) {
                            throw (0, $eb8eb3b792f36778$export$ae1af26003f05816)(request)(error);
                        } finally{
                            if ((0, $cXtTj.default).checkGate("post_office_enable-visualization")) middlewareRequest.location.stopTimer();
                            withRequestMetadata(ctx);
                        }
                    };
                    const dataMiddleware = async (ctx, next)=>{
                        const { request: request, messagesRuntime: messagesRuntime } = buildPlacementContext(ctx, next);
                        const middlewareRequest = request.location.tag({
                            placementLevel: "Middleware"
                        });
                        try {
                            ctx.body = await messagesRuntime({
                                request: middlewareRequest
                            });
                            ctx.status = 200;
                        } catch (error) {
                            throw (0, $eb8eb3b792f36778$export$ae1af26003f05816)(request)(error);
                        } finally{
                            if ((0, $cXtTj.default).checkGate("post_office_enable-visualization")) middlewareRequest.location.stopTimer();
                            withRequestMetadata(ctx);
                        }
                    };
                    const describe = ()=>{
                        const messageTemplates = placementBackendConfig.messageTemplates.map(([id, stages])=>{
                            return {
                                id: id,
                                stages: Object.keys(stages)
                            };
                        });
                        return {
                            placementId: placementConfig.placementId,
                            messageTemplates: messageTemplates
                        };
                    };
                    const standaloneRuntime = async (config)=>{
                        if (!config?.request) throw new (0, $eb8eb3b792f36778$export$43caf9889c228507)({
                            message: "request is required when calling runtime directly"
                        });
                        const request = config.request.location.tag({
                            placementId: placementConfig.placementId,
                            placementLevel: "Runtime"
                        });
                        const combinedParams = {
                            ...placementBackendParams?.params,
                            ...config?.params
                        };
                        try {
                            const runtimeStartTime = performance.now();
                            const result = await $06fb173e15603c4d$var$placementRuntimeTimedStage(statelessMessagesRuntime)({
                                request: request
                            })(combinedParams);
                            const runtimeLatencyInMs = performance.now() - runtimeStartTime;
                            $06fb173e15603c4d$var$logRuntimeResult({
                                request: request
                            })({
                                result: result,
                                latencyInMs: runtimeLatencyInMs
                            });
                            return result;
                        } catch (error) {
                            throw (0, $eb8eb3b792f36778$export$2408f22a0fab9ae5)(request)(error);
                        }
                    };
                    return {
                        middleware: koaMiddleware,
                        endpoints: {
                            renderer: koaMiddleware,
                            data: dataMiddleware
                        },
                        config: {
                            ...placementBackendConfig,
                            ...placementBackendParams,
                            ...placementConfig
                        },
                        describe: describe,
                        runtime: standaloneRuntime
                    };
                }
        });
const $06fb173e15603c4d$var$applyDefaultMessageBackendStages = (stages)=>{
    const validatedDefaultStages = {};
    Object.entries($06fb173e15603c4d$var$defaultBackendPlacementMessageStages).forEach(([stageName, stage])=>{
        validatedDefaultStages[stageName] = {
            validate: $06fb173e15603c4d$export$2408f22a0fab9ae5(),
            stage: stage
        };
    });
    return {
        ...validatedDefaultStages,
        ...stages()
    };
};
const $06fb173e15603c4d$export$43caf9889c228507 = (config)=>{
    return (placementMessageStages)=>{
        const placementStages = config(placementMessageStages);
        const wrappedPlacementStages = {};
        Object.entries(placementStages).forEach(([stageName, stage])=>{
            if (!stage) wrappedPlacementStages[stageName] = void 0;
            wrappedPlacementStages[stageName] = $06fb173e15603c4d$var$createBackendPlacementRunner({
                stageName: stageName,
                stage: stage
            });
        });
        return wrappedPlacementStages;
    };
};
const $06fb173e15603c4d$var$createBackendPlacementRunner = ({ stageName: stageName, stage: stage })=>async (params)=>{
        const request = params.request.location.tag({
            placementLevel: "Placement",
            stageName: stageName
        });
        if (!stage) return params.data;
        try {
            return await $06fb173e15603c4d$var$placementTimedStage(stage)({
                request: request,
                data: params.data
            });
        } catch (error) {
            throw (0, $eb8eb3b792f36778$export$23f2a1d2818174ef)(request)(error);
        }
    };
const $06fb173e15603c4d$export$7ccc53e8f1e7dfc5 = (config)=>{
    const result = {};
    config.messageTemplates.forEach(([messageTemplateId, stages])=>Object.entries(stages).forEach(([stageName, stage])=>{
            if (!result[messageTemplateId]) result[messageTemplateId] = {};
            result[messageTemplateId][stageName] = $06fb173e15603c4d$var$createBackendPlacementMessageRunner({
                stage: stage,
                stageName: stageName,
                placementId: config.placementId
            });
        }));
    return result;
};
const $06fb173e15603c4d$var$createBackendPlacementMessageRunner = (config)=>{
    return async (input)=>{
        const { message: message } = input;
        const request = input.request.location.tag({
            placementLevel: "Message",
            messageTemplateId: message?.messageTemplateId,
            messageInstanceId: message?.messageInstanceId,
            triggerId: message?.triggerId,
            stageName: config?.stageName
        });
        try {
            const { validate: validate, stage: stage } = config.stage;
            validate(input.message.context);
            const hydratedContext = await (request.messagePerformance ?? new (0, $eeedeb00cf693440$export$f5bd5a7a850da66e)(request, {
                trackEndToEnd: false,
                metricNameSegments: {
                    flow: "pull",
                    placementId: config.placementId
                }
            })).measureOperation(async ()=>await $06fb173e15603c4d$var$messageTimedStage(stage)({
                    request: request,
                    message: message
                }), {
                messageTemplateId: message.messageTemplateId,
                operation: config.stageName,
                stage: "hydration"
            }, {
                layer: "message"
            });
            return {
                ...message,
                context: {
                    ...hydratedContext,
                    ...message.context.triggerType !== void 0 ? {
                        triggerType: message.context.triggerType
                    } : {}
                }
            };
        } catch (error) {
            throw (0, $eb8eb3b792f36778$export$407448d2b89b1813)(request)(error);
        }
    };
};
//#endregion
//#region src/backend/default-headless-placement-backend.ts
/**
* Type-safe factory helpers for message templates installed into backend-only placements.
*
* Use this when there is no real PlacementBackend to import from a placement-specific package.
* The actual placement (with the correct placement ID derived from the folder name) is created
* at install time via the CLI — this object only provides the message-level factory methods.
*/ const $06fb173e15603c4d$export$625550452a3fa3ec = {
    createMessageBackend: (stages)=>$06fb173e15603c4d$export$407448d2b89b1813(stages),
    withDefaultMessageBackend: ()=>$06fb173e15603c4d$export$407448d2b89b1813($06fb173e15603c4d$export$ae1af26003f05816)
};
module.exports["o"] = $06fb173e15603c4d$export$ae1af26003f05816;
module.exports["s"] = $06fb173e15603c4d$export$2408f22a0fab9ae5;
module.exports["i"] = $06fb173e15603c4d$export$23f2a1d2818174ef;

});

parcelRegister("fs98n", function(module, exports) {
//#region src/create-placement/util/flatten-messages-for-frontend/index.ts
const $b4008e6503a075c8$var$flattenMessageForFrontend = ({ context: context, ...message })=>({
        ...message,
        ...context
    });
/**
* By convention we flatten the response on the backend so we aren't so reliant on memoizing props on the frontend.
*/ const $b4008e6503a075c8$export$23f2a1d2818174ef = (messages)=>messages.map($b4008e6503a075c8$var$flattenMessageForFrontend);
//#endregion
//#region src/create-placement/default-placement-middleware/index.ts
const $b4008e6503a075c8$export$625550452a3fa3ec = (execute)=>(params)=>async ({ request: request, koa: koa, postOffice: postOffice, placement: placement })=>{
            try {
                const result = await execute({
                    request: request,
                    koa: koa,
                    postOffice: postOffice,
                    placement: placement,
                    params: params
                });
                koa.ctx.body = result;
                koa.ctx.status = 200;
            } catch (error) {
                request.logger.error({
                    error: error
                }, "placement middleware error");
                koa.ctx.status = 500;
                koa.ctx.body = {
                    message: "An error occurred"
                };
            }
        };
const $b4008e6503a075c8$export$7ccc53e8f1e7dfc5 = $b4008e6503a075c8$export$625550452a3fa3ec(async ({ postOffice: postOffice })=>{
    const result = await postOffice.messagesRuntime();
    $b4008e6503a075c8$export$43caf9889c228507(result);
    return {
        ...result.data,
        messages: $b4008e6503a075c8$export$23f2a1d2818174ef(result.data.messages)
    };
});
const $b4008e6503a075c8$export$43caf9889c228507 = ({ errors: errors, data: data })=>{
    const { messages: messages } = data;
    if (!(messages.length > 1)) return;
    const uniqueErrorIds = new Set(errors.map((e)=>e?.messageTemplateId ?? "unknown"));
    const uniqueMessageIds = new Set(messages.map((e)=>e.messageTemplateId));
    if (uniqueErrorIds.size > 1 && uniqueMessageIds.size / uniqueMessageIds.size > .1) throw new Error("too many message template errors");
};
module.exports["i"] = $b4008e6503a075c8$export$23f2a1d2818174ef;
module.exports["t"] = $b4008e6503a075c8$export$625550452a3fa3ec;
module.exports["n"] = $b4008e6503a075c8$export$7ccc53e8f1e7dfc5;
module.exports["r"] = $b4008e6503a075c8$export$43caf9889c228507;

});

parcelRegister("f3m05", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $4fmou = parcelRequire("4fmou");

//#region src/create-placement/i18n/index.tsx
const $af5833a9d0e560cb$export$920091e3d72d80ee = (loaders)=>{
    const messagesLoader = $af5833a9d0e560cb$export$99ce90405b04bcbd(loaders);
    const I18n = ({ children: children })=>/* @__PURE__ */ (0, $8aG6j.jsx)((0, $4fmou.IntlProvider), {
            messagesLoader: messagesLoader,
            children: children
        });
    return ({ children: children })=>{
        return /* @__PURE__ */ (0, $8aG6j.jsx)(I18n, {
            children: children
        });
    };
};
const $af5833a9d0e560cb$export$d71c6502467fe725 = (...loaders)=>{
    const messagesLoader = $af5833a9d0e560cb$export$99ce90405b04bcbd(...loaders);
    return (component)=>{
        return (0, $4fmou.withIntlProvider)({
            messagesLoader: messagesLoader
        }, component);
    };
};
const $af5833a9d0e560cb$export$99ce90405b04bcbd = (...loaders)=>async (locale)=>{
        const messagePromises = loaders.filter((e)=>!!e).map((loader)=>loader(locale));
        const loadedMessages = await Promise.allSettled(messagePromises);
        const translatedMessages = {
            messages: {},
            errors: []
        };
        loadedMessages.forEach((result)=>{
            if (result.status === "rejected") {
                translatedMessages.errors.push(`Failed to load translations with ${result.reason}`);
                return;
            }
            translatedMessages.messages = {
                ...translatedMessages.messages,
                ...result.value
            };
        });
        return translatedMessages;
    };
module.exports["createWithI18n"] = $af5833a9d0e560cb$export$d71c6502467fe725;

});


//# sourceMappingURL=ShareAndRestrictDialog.3bea1a9d.js.map
